#import './emailable-lead-fragment.graphql'

fragment EntityRelatedEmailAddresses on CoreEntity {
    id
    type
    name
    htmlUrl
    relatedEmailAddresses {
        ...RelatedEmailAddresses
    }
    emailableLeads {
        ...EmailableLead
    }
}

fragment RelatedEmailAddresses on EmailAddressesEavConnection {
    primary {
        ...EmailAddress
    }
    all {
        ...EmailAddress
    }
}

fragment EmailAddress on EmailAddressEav {
    id
    name
    isPrimary
    isFormer
    value {
        address
        display
        formatted
    }
    entity {
        id
        name
        ... on Contact {
            primaryEmailAddress
        }
        ... on Account {
            primaryEmailAddress
        }
        ... on User {
            primaryEmailAddress
        }
        ... on ActivityParticipant {
            primaryEmailAddress
        }
    }
}
